import React, { useEffect, useRef } from "react";
import WaterfallChart from "../../graphs/WaterfallChart";

interface Props {
  formattedData: any[];
  BoxformattedData: any[];
}

const WinsCharts : React.FC<Props> = ({ formattedData , BoxformattedData}) => {
  const stepValuesRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (stepValuesRef.current) {
      stepValuesRef.current.innerHTML = ""; // Clear previous content

      BoxformattedData.forEach((item, index) => {
        const mainBox = document.createElement("div");
        mainBox.className = "mainBox";
        const labelBox = document.createElement("div");
        labelBox.style.color = "#fff";
        if (index === 0) {
          labelBox.innerText = "Budget Amended";
          labelBox.style.width = "80px";
        } else if (index === BoxformattedData.length - 1) {
          labelBox.innerText = "Actuals";
        } else if (index === BoxformattedData.length - 2) {
          labelBox.innerText = "Tail Market";
        } else if (index === BoxformattedData.length - 3) {
          labelBox.innerText = "Next5";
        }
        const stepValueBox = document.createElement("div");
        stepValueBox.style.display = "inline-block";
        stepValueBox.style.width = "70px";
        stepValueBox.style.height = "30px";
        stepValueBox.style.margin = "5px";
        stepValueBox.style.color = "#fff";
        stepValueBox.style.textAlign = "center";
        stepValueBox.style.lineHeight = "30px";

        // Set background color based on item type
        if (index === 0 || index === BoxformattedData.length - 1) {
          stepValueBox.style.backgroundColor = "#FFFFFF"; // White for first and last
          stepValueBox.style.color = "#000000"; // Black text for contrast
        } else if (Number(item.BoxValue) <= 0) {
          stepValueBox.style.backgroundColor = "#0B70A9"; // Blue for decreasing step
        } else if (Number(item.BoxValue) > 0) {
          stepValueBox.style.backgroundColor = "#E9D40B"; // Yellow for increasing step
          stepValueBox.style.color = "#000000"; // Black text for contrast
        }

        // Use displayValue for the first and last items, stepValue for others
        stepValueBox.innerText = item.BoxValue;
        mainBox.appendChild(stepValueBox);
        mainBox.appendChild(labelBox);

        if (stepValuesRef.current) {
          stepValuesRef.current.appendChild(mainBox);
        }
      });
    }
  }, [BoxformattedData, formattedData]);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="chartTitleData">
          <h2 className="ChartTitle">Q1 Volume Wins and Misses</h2>
          <p>
            ABI closed Q1 volume{" "}
            <span className="yellow">
              {" "}
              {BoxformattedData.length &&
              BoxformattedData[BoxformattedData.length - 1]["BoxValue"] -
                BoxformattedData[0]["BoxValue"] >
                0
                ? "+"
                : ""}
              {BoxformattedData.length > 0
                ? (
                    BoxformattedData[BoxformattedData.length - 1]["BoxValue"] -
                    BoxformattedData[0]["BoxValue"]
                  ).toFixed(1)
                : ""}{" "}
              Mhl
            </span>{" "}
            below Budget with biggest headwind in China. Volumes were overall
            lower than Global (0+12) forecasts by 1.6 Mhl.
          </p>
        </div>
      </div>
      <div className="col-md-12">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="BannData text-center py-5">
                <div className="volumeChart">
                  <div className="subVolumeChart">
                    {formattedData && <WaterfallChart data={formattedData} />}
                    <div className="dis_f_c">
                      <div className="r_90">
                        <p style={{ display: "contents", color: "#fff" }}>
                          Volume (Mhl)
                        </p>
                      </div>
                      <div style={{ width: "100%" }}>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            position: "relative",
                            marginTop: "30px",
                            paddingRight: "20px",
                          }}
                        >
                          {/* box above line */}
                          <hr
                            style={{
                              border: "1px solid #707070",
                              position: "relative",
                              top: "10px",
                              backgroundColor: "black",
                              paddingRight: "20px",
                              // marginBottom:'30px',
                              opacity: "1",
                            }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "50%",
                              transform: "translateX(-50%)",
                              background: "#000000",
                              color: "#ffffff",
                              padding: "0 10px",
                              borderRadius: "8px",
                              border: "1px solid #707070",
                            }}
                          >
                            {BoxformattedData.length > 0
                              ? (
                                  BoxformattedData[BoxformattedData.length - 1][
                                    "BoxValue"
                                  ] - BoxformattedData[0]["BoxValue"]
                                ).toFixed(1)
                              : ""}{" "}
                            Mhl{" "}
                            {BoxformattedData.length &&
                            BoxformattedData[BoxformattedData.length - 1][
                              "BoxValue"
                            ] -
                              BoxformattedData[0]["BoxValue"] >
                              0
                              ? " higher"
                              : " lower"}{" "}
                            (
                            {BoxformattedData.length
                              ? (
                                  ((BoxformattedData[
                                    BoxformattedData.length - 1
                                  ]["BoxValue"] -
                                    BoxformattedData[0]["BoxValue"]) /
                                    BoxformattedData[0]["BoxValue"]) *
                                  100
                                ).toFixed(1)
                              : ""}
                            %)
                          </span>
                          <div
                            style={{
                              position: "absolute",
                              left: "0%",
                              transform: "translateX(-50%)",
                              color: "#fff",
                              top: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="5"
                              height="39"
                              viewBox="0 0 5 39"
                              fill="none"
                            >
                              <path
                                d="M2.50586 38.4637L4.48055 35.0435L0.531166 35.0435L2.50586 38.4637ZM2.16383 0.156738L2.16383 35.3855L2.84788 35.3855L2.84789 0.156738L2.16383 0.156738Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "20px",
                              transform: "translateX(50%)",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="5"
                              height="39"
                              viewBox="0 0 5 39"
                              fill="none"
                            >
                              <path
                                d="M2.50586 38.4637L4.48055 35.0435L0.531166 35.0435L2.50586 38.4637ZM2.16383 0.156738L2.16383 35.3855L2.84788 35.3855L2.84789 0.156738L2.16383 0.156738Z"
                                fill="white"
                              />
                            </svg>
                          </div>
                        </div>
                        <div
                          ref={stepValuesRef}
                          style={{
                            display: "flex",
                            justifyContent: "space-around",
                            // border: "1px solid #fff",
                            flexWrap: "wrap",
                            paddingTop: "50px",
                            paddingLeft: "0px",
                            paddingRight: "20px",
                          }}
                        ></div>
                        <div
                          style={{
                            width: "100%",
                            textAlign: "center",
                            position: "relative",
                            marginTop: "10px",
                          }}
                        >
                          {/* line below box */}
                          <hr
                            style={{
                              border: "1px solid #707070",
                              position: "relative",
                              top: "10px",
                              backgroundColor: "black",
                              paddingRight: "20px",
                              marginBottom: "30px",
                              opacity: "1",
                              marginRight: "355px",
                              marginLeft: "130px",
                            }}
                          />

                          <span
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "41%",
                              transform: "translateX(-50%)",
                              background: "#000000",
                              color: "#ffffff",
                              padding: "0 10px",
                              borderRadius: "8px",
                              border: "1px solid #707070",
                            }}
                          >
                            Top 10 Market
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WinsCharts;
